import { storeToRefs } from 'pinia';
import { convertCurrency } from '@/helpers/currency.helper';
import { isPreferredCurrency } from '~/constants/currency';

const amountFormatter = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 });

export function useAedMoneyDisplay() {
  const preferences = usePreferencesStore();
  const { currency } = storeToRefs(preferences);

  function formatFromAed(amount: number | null | undefined) {
    const n = Number(amount ?? 0);
    const converted = convertCurrency(n, 'AED', currency.value);
    return `${amountFormatter.format(converted)} ${currency.value}`;
  }

  function formatAmount(amount: number | null | undefined, fromCurrency: string = 'AED') {
    const n = Number(amount ?? 0);
    const from = isPreferredCurrency(fromCurrency) ? fromCurrency : 'AED';
    const converted = convertCurrency(n, from, currency.value);
    return `${amountFormatter.format(converted)} ${currency.value}`;
  }

  function formatAedBand(minAed: number, maxInclusiveAed: number | null) {
    if (maxInclusiveAed === null) return `${formatFromAed(minAed)}+`;
    return `${formatFromAed(minAed)} – ${formatFromAed(maxInclusiveAed)}`;
  }

  return {
    formatFromAed,
    formatAmount,
    formatAedBand,
    displayCurrency: currency,
  };
}
